module.exports = __webpack_public_path__ + "img/machinered.ab220765.svg";